import styled from 'styled-components';
import tw from 'twin.macro';

import { colors } from '../../themes/Colors';

export const LoadingViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FailureViewContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FailureViewMessage = styled.p`
  ${tw`mt-20px mr-10px mb-15px ml-10px text-center font-inter`};
  width: 500px;
  font-size: 20px;
  color: ${colors.marineBlueThree};
  white-space: pre-wrap;

  @media (max-width: 768px) {
    ${tw`w-300px`}
    font-size:15px
  }
  @media (min-width: 500px) and (max-width: 767px) {
    width: 450px;
    font-size: 18px;
  }
`;

export const RetryButton = styled.button`
  ${tw`outline-none text-white px-6 py-1 text-14px`}
  background: ${colors.ceruleanBlue};
  border-radius: 16px;
  cursor: pointer;
`;

export const FailureImage = styled.img`
  width: 400px;
  height: auto;
  @media (max-width: 768px) {
    width: 300px;
    height: 177px;
  }
`;
